import React from 'react';
import { Menu } from '@comparaonline/navigation/compara-ui-navigation';

export const MenuApp = () => {
  const menuConfig = window.navigationConfig.menu;

  return (
    <>
      <Menu {...menuConfig} />
    </>
  );
};
